import { StanButton, StanModal } from '@/components';

interface HideFunnelEntryPageModalProps {
    isOpen: boolean;
    onClose: () => void;
    pageTitle: string;
    newEntryTitle: string;
    isHiding: boolean;
    onConfirm: () => void;
}

export const HideFunnelEntryPageModal = ({
    isOpen,
    onClose,
    pageTitle,
    newEntryTitle,
    isHiding,
    onConfirm,
}: HideFunnelEntryPageModalProps) => {
    return (
        <StanModal id='hide-funnel-entry-page-modal' isOpen={isOpen} onClose={onClose} title='Hide Entry Page'>
            <div className='flex flex-col gap-4'>
                <p className='text-body-md text-gray text-center'>
                    Hiding <strong className='text-dark'>{pageTitle}</strong> will promote{' '}
                    <strong className='text-dark'>{newEntryTitle}</strong> to the entry page. Entry pages can&apos;t
                    have upsells or downsells, so its branches will be detached and moved to the main flow.
                </p>
                <div className='flex w-full gap-1 pt-2 max-sm:flex-col sm:gap-2'>
                    <StanButton name='cancel-hide-entry-page' variant='outline' onClick={onClose} className='w-full'>
                        Cancel
                    </StanButton>
                    <StanButton
                        name='confirm-hide-entry-page'
                        onClick={onConfirm}
                        disabled={isHiding}
                        className='w-full'
                    >
                        {isHiding ? 'Hiding...' : 'Hide & Detach Branches'}
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
};
